import routeParams from 'helpers/routeParams'
import { sameIdsIn } from '../../../utils/array'
import { intersection } from 'lodash'
import { mapForBulk } from '../../selectors/participants/mapParticipantsForBulk'

const GET_LEADERS_LIST = 'dofe-bo/LEADER/GET_LEADERS_LIST'
const GET_LEADERS_LIST_SUCCESS = 'dofe-bo/LEADER/GET_LEADERS_LIST_SUCCESS'
const GET_LEADERS_LIST_FAIL = 'dofe-bo/LEADER/GET_LEADERS_LIST_FAIL'

const GET_LEADERS_FOR_SEARCH_LIST = 'dofe-bo/LEADER/GET_LEADERS_FOR_SEARCH_LIST'
const GET_LEADERS_FOR_SEARCH_LIST_SUCCESS = 'dofe-bo/LEADER/GET_LEADERS_FOR_SEARCH_LIST_SUCCESS'
const GET_LEADERS_FOR_SEARCH_LIST_FAIL = 'dofe-bo/LEADER/GET_LEADERS_FOR_SEARCH_LIST_FAIL'

const GET_LEADER = 'dofe-bo/LEADER/GET_LEADER'
const GET_LEADER_SUCCESS = 'dofe-bo/LEADER/GET_LEADER_SUCCESS'
const GET_LEADER_FAIL = 'dofe-bo/LEADER/GET_LEADER_FAIL'

const UPDATE_LEADER = 'dofe-bo/LEADER/UPDATE_LEADER'
const UPDATE_LEADER_SUCCESS = 'dofe-bo/LEADER/UPDATE_LEADER_SUCCESS'
const UPDATE_LEADER_FAIL = 'dofe-bo/LEADER/UPDATE_LEADER_FAIL'

const FIND_LEADER = 'dofe-bo/LEADER/FIND_LEADER'
const FIND_LEADER_SUCCESS = 'dofe-bo/LEADER/FIND_LEADER_SUCCESS'
const FIND_LEADER_FAIL = 'dofe-bo/LEADER/FIND_LEADER_FAIL'
const APPROVE_LEADER = 'dofe-bo/LEADER/APPROVE_LEADER'
const APPROVE_LEADER_SUCCESS = 'dofe-bo/LEADER/APPROVE_LEADER_SUCCESS'
const APPROVE_LEADER_FAIL = 'dofe-bo/LEADER/APPROVE_LEADER_FAIL'
const ADD_TRAINING = 'dofe-bo/LEADER/ADD_TRAINING'
const ADD_TRAINING_SUCCESS = 'dofe-bo/LEADER/ADD_TRAINING_SUCCESS'
const ADD_TRAINING_FAIL = 'dofe-bo/LEADER/ADD_TRAINING_FAIL'
const UPDATE_TRAINING = 'dofe-bo/LEADER/UPDATE_TRAINING'
const UPDATE_TRAINING_SUCCESS = 'dofe-bo/LEADER/UPDATE_TRAINING_SUCCESS'
const UPDATE_TRAINING_FAIL = 'dofe-bo/LEADER/UPDATE_TRAINING_FAIL'

const DELETE_TRAINING = 'dofe-bo/LEADER/DELETE_TRAINING'
const DELETE_TRAINING_SUCCESS = 'dofe-bo/LEADER/DELETE_TRAINING_SUCCESS'
const DELETE_TRAINING_FAIL = 'dofe-bo/LEADER/DELETE_TRAINING_FAIL'

const CRUD_HISTORY_RECORD = 'dofe-bo/LEADER/CRUD_HISTORY_RECORD'
const CRUD_HISTORY_RECORD_SUCCESS = 'dofe-bo/LEADER/CRUD_HISTORY_RECORD_SUCCESS'
const CRUD_HISTORY_RECORD_FAIL = 'dofe-bo/LEADER/CRUD_HISTORY_RECORD_FAIL'

const MOVE_LEADER = 'dofe-bo/LEADER/MOVE_LEADER'
const MOVE_LEADER_SUCCESS = 'dofe-bo/LEADER/MOVE_LEADER_SUCCESS'
const MOVE_LEADER_FAIL = 'dofe-bo/LEADER/MOVE_LEADER_FAIL'

const SEND_CONFIRMATION_EMAIL = 'dofe-bo/LEADER/SEND_CONFIRMATION_EMAIL'
const SEND_CONFIRMATION_EMAIL_SUCCESS =
  'dofe-bo/LEADER/SEND_CONFIRMATION_EMAIL_SUCCESS'
const SEND_CONFIRMATION_EMAIL_FAIL =
  'dofe-bo/LEADER/SEND_CONFIRMATION_EMAIL_FAIL'

const TRANSFER_PARTICIPANTS = 'dofe-bo/LEADER/TRANSFER_PARTICIPANTS'
const TRANSFER_PARTICIPANTS_SUCCESS =
  'dofe-bo/LEADER/TRANSFER_PARTICIPANTS_SUCCESS'
const TRANSFER_PARTICIPANTS_FAIL = 'dofe-bo/LEADER/TRANSFER_PARTICIPANTS_FAIL'

const EXPORT_LEADERS_LIST = 'dofe-bo/LEADER/EXPORT_LEADERS_LIST'
const EXPORT_LEADERS_LIST_SUCCESS = 'dofe-bo/LEADER/EXPORT_LEADERS_LIST_SUCCESS'
const EXPORT_LEADERS_LIST_FAIL = 'dofe-bo/LEADER/EXPORT_LEADERS_LIST_FAIL'

const SET_FILTER = 'dofe-bo/LEADER/SET_FILTER'
const SET_PARAMS = 'dofe-bo/LEADER/SET_PARAMS'

const RESET_LEADER_DETAIL = 'dofe-bo/LEADER/RESET_LEADER_DETAIL'

const SET_LEADERS_LIST_SELECTED = 'dofe-bo/participant/SET_LEADERS_LIST_SELECTED'
const TOGGLE_LEADERS_ALL_SELECTED = 'dofe-bo/participant/TOGGLE_LEADERS_ALL_SELECTED'
const BULK_AWARD_LEADERS_RESET = 'dofe-bo/participant/BULK_AWARD_LEADERS_RESET'


const initialState = {
  list: [],
  searchList: [],
  detail: {},
  sort: '',
  offset: 0,
  limit: 20,
  pages: 1,
  count: null,
  filter: '',
  loading: false,
  loaded: false,
  selectedIds: [],
  bulk: {
    loading: false,
    loaded: false
  }
}

export default function reducer(state = initialState, action = {}) {
  // const dataFor = {}
  switch (action.type) {
    case GET_LEADERS_LIST:
      return {
        ...state,
        loading: true
      }
    case GET_LEADERS_LIST_SUCCESS:
      // for (const item of action.result) {
      //   dataFor[item.id] = item
      // }
      return {
        ...state,
        loading: false,
        loaded: true,
        list: action.result,
        count: Number(action.headers['x-total-count']),
        pages:
          Math.ceil(Number(action.headers['x-total-count']) / state.limit) ||
          state.pages
      }
    case GET_LEADERS_LIST_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case GET_LEADERS_FOR_SEARCH_LIST:
      return {
        ...state,
        loading: true
      }
    case GET_LEADERS_FOR_SEARCH_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        searchList: action.result,
        count: Number(action.headers['x-total-count']),
        pages:
          Math.ceil(Number(action.headers['x-total-count']) / state.limit) ||
          state.pages
      }
    case GET_LEADERS_FOR_SEARCH_LIST_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case GET_LEADER:
      return {
        ...state,
        loading: true
      }
    case GET_LEADER_SUCCESS:
      return {
        ...state,
        loading: false,
        detail: action.result
      }
    case GET_LEADER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error
      }
    case RESET_LEADER_DETAIL:
      return {
        ...state,
        loading: false,
        detail: {}
      }
    case TRANSFER_PARTICIPANTS:
      return {
        ...state,
        loading: true
      }
    case TRANSFER_PARTICIPANTS_SUCCESS:
      return {
        ...state,
        loading: false
      }
    case TRANSFER_PARTICIPANTS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error
      }
    case FIND_LEADER:
      return {
        ...state,
        loading: true
      }
    case FIND_LEADER_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: false,
        list: action.result
      }
    case FIND_LEADER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error
      }
    case SET_FILTER:
      return Object.assign({}, state, {
        filter: action.filterBy,
        offset: 0,
        invalidate: new Date().getTime()
      })
    case SET_PARAMS:
      return {
        ...state,
        limit:
          action.options.limit !== undefined
            ? action.options.limit
            : state.limit,
        offset:
          action.options.offset !== undefined
            ? action.options.offset
            : state.offset,
        filter:
          action.options.filter !== undefined
            ? action.options.filter
            : state.filter,
        sort:
          action.options.sort !== undefined ? action.options.sort : state.sort
      }
    case SET_LEADERS_LIST_SELECTED:
      return {
        ...state,
        selectedIds: action.bulkType
            ? intersection(action.selectedIds,
                mapForBulk(state.list || [], action.bulkType))
            : action.selectedIds
      }
    case TOGGLE_LEADERS_ALL_SELECTED:
      if (sameIdsIn(action.selectedIds, action.selectableIds)) {
        return {
          ...state,
          selectedIds: []
        }
      }

      return {
        ...state,
        selectedIds: [...action.selectableIds]
      }
    case BULK_AWARD_LEADERS_RESET:
      return {
        ...state,
        bulk: {
          loading: false,
          loaded: false
        }
      }
    default:
      return state
  }
}

export function getLeaders(
  params = {},
  baseFilter,
  { disableQueryFilter, onlyActive } = {}
) {
  let appendBaseFilter = baseFilter
    ? `${baseFilter},isAwardLeader=1`
    : 'isAwardLeader=1'

  const urlReadParams = 'PERSON,ORGANIZATION,ORGANIZATION_PARENT,LABELS'

  if (onlyActive) {
    appendBaseFilter = `${appendBaseFilter},person.personState.value=ACTIVE`
  }

  const queryParams = disableQueryFilter ? {} : params

  return {
    types: [GET_LEADERS_LIST, GET_LEADERS_LIST_SUCCESS, GET_LEADERS_LIST_FAIL],
    promise: client =>
      client.get(
        `api/leaders?with=${urlReadParams}${routeParams(
          queryParams,
          appendBaseFilter
        )}`
      )
  }
}

export function getLeadersForSearch(params = {}, baseFilter, { disableQueryFilter, onlyActive } = {}) {
  let appendBaseFilter = baseFilter ? `${baseFilter},isAwardLeader=1` : 'isAwardLeader=1'
  const urlReadParams = 'PERSON,ORGANIZATION,ORGANIZATION_PARENT'

  if (onlyActive) {
    appendBaseFilter = `${appendBaseFilter},person.personState.value=ACTIVE`
  }

  const queryParams = disableQueryFilter ? {} : params

  return {
    types: [GET_LEADERS_FOR_SEARCH_LIST, GET_LEADERS_FOR_SEARCH_LIST_SUCCESS, GET_LEADERS_FOR_SEARCH_LIST_FAIL],
    promise: client =>
      client.get(
        `api/leaders?with=${urlReadParams}${routeParams(
          queryParams,
          appendBaseFilter
        )}`
      )
  }
}

export function getLeader(id, { readParams } = {}) {
  const urlReadParams = readParams
    ? `PERSON,ORGANIZATION,ORGANIZATION_PARENT,PERSON_ADDRESS,LABELS,${readParams}`
    : 'PERSON,ORGANIZATION,ORGANIZATION_PARENT,PERSON_ADDRESS,LABELS'

  return {
    types: [GET_LEADER, GET_LEADER_SUCCESS, GET_LEADER_FAIL],
    promise: client => client.get(`api/leaders/${id}?with=${urlReadParams}`)
  }
}

export function updateLeader(id, data) {
  return {
    types: [UPDATE_LEADER, UPDATE_LEADER_SUCCESS, UPDATE_LEADER_FAIL],
    promise: client =>
      client.put(`api/leaders/${id}?update=PERSON,ORGANIZATION`, {
        data
      })
  }
}

export function findLeader(filter = '') {
  return {
    types: [FIND_LEADER, FIND_LEADER_SUCCESS, FIND_LEADER_FAIL],
    promise: client =>
      client.get(`api/leaders?with=PERSON,ORGANIZATION&filter=${filter}`)
  }
}

export function approveAwardLeader(id, data) {
  return {
    types: [APPROVE_LEADER, APPROVE_LEADER_SUCCESS, APPROVE_LEADER_FAIL],
    promise: client =>
      client.post(`api/award-leader-registration-approval/${id}`, {
        data
      })
  }
}

export function addTraining(id, data) {
  return {
    types: [ADD_TRAINING, ADD_TRAINING_SUCCESS, ADD_TRAINING_FAIL],
    promise: client =>
      client.post(`api/leaders/${id}/awardLeaderTrainings`, {
        data
      })
  }
}

export function updateTraining(id, trainingId, data) {
  return {
    types: [UPDATE_TRAINING, UPDATE_TRAINING_SUCCESS, UPDATE_TRAINING_FAIL],
    promise: client =>
      client.post(`api/leaders/${id}/awardLeaderTrainings/${trainingId}/edit`, {
        data
      })
  }
}

export function deleteTraining(id, trainingId) {
  return {
    types: [DELETE_TRAINING, DELETE_TRAINING_SUCCESS, DELETE_TRAINING_FAIL],
    promise: client =>
      client.del(`api/leaders/${id}/awardLeaderTrainings/${trainingId}`)
  }
}

export function addHistoryRecord(leaderId, data) {
  return {
    types: [
      CRUD_HISTORY_RECORD,
      CRUD_HISTORY_RECORD_SUCCESS,
      CRUD_HISTORY_RECORD_FAIL
    ],
    promise: client =>
      client.post(`api/leaders/${leaderId}/award-leadership-history`, {
        data
      })
  }
}

export function updateHistoryRecord(leaderId, historyRecordId, data) {
  return {
    types: [
      CRUD_HISTORY_RECORD,
      CRUD_HISTORY_RECORD_SUCCESS,
      CRUD_HISTORY_RECORD_FAIL
    ],
    promise: client =>
      client.post(
        `api/leaders/${leaderId}/award-leadership-history/${historyRecordId}/edit`,
        {
          data
        }
      )
  }
}

export function deleteHistoryRecord(leaderId, historyRecordId) {
  return {
    types: [
      CRUD_HISTORY_RECORD,
      CRUD_HISTORY_RECORD_SUCCESS,
      CRUD_HISTORY_RECORD_FAIL
    ],
    promise: client =>
      client.del(
        `api/leaders/${leaderId}/award-leadership-history/${historyRecordId}`
      )
  }
}

export function moveLeader(id, awardUnitId) {
  return {
    types: [MOVE_LEADER, MOVE_LEADER_SUCCESS, MOVE_LEADER_FAIL],
    promise: client =>
      client.post(
        `api/leaders/${id}/moving-to-another-award-unit?awardUnitId=${awardUnitId}`
      )
  }
}

export function sendConfirmationEmail(id) {
  return {
    types: [
      SEND_CONFIRMATION_EMAIL,
      SEND_CONFIRMATION_EMAIL_SUCCESS,
      SEND_CONFIRMATION_EMAIL_FAIL
    ],
    promise: client =>
      client.post(
        `api/award-leader-registration/${id}/resend-confirmation-email`
      )
  }
}

export function exportLeaders(params = {}, baseFilter) {
  return {
    types: [
      EXPORT_LEADERS_LIST,
      EXPORT_LEADERS_LIST_SUCCESS,
      EXPORT_LEADERS_LIST_FAIL
    ],
    promise: client =>
      client.get(
        `api/leaders?with=PERSON,ORGANIZATION,LABELS,ORGANIZATION_PARENT${routeParams(
          {
            filter: params.filter
          },
          baseFilter,
          { baseSort: '+firstName' }
        )}`
      )
  }
}

export function transferLeaderParticipants(leaderId, newLeaderId) {
  return {
    types: [
      TRANSFER_PARTICIPANTS,
      TRANSFER_PARTICIPANTS_SUCCESS,
      TRANSFER_PARTICIPANTS_FAIL
    ],
    promise: client =>
      client.post(
        `api/leaders/${leaderId}/transferring-participants?newAwardLeaderId=${newLeaderId}`
      )
  }
}

export function setLeadersSelected(selectedIds, bulkType) {
  return {
    type: SET_LEADERS_LIST_SELECTED,
    selectedIds,
    bulkType
  }
}

export function toggleLeadersAllSelected(selectedIds, selectableIds) {
  return {
    type: TOGGLE_LEADERS_ALL_SELECTED,
    selectedIds,
    selectableIds
  }
}

export function bulkAwardLeadersReset() {
  return {
    type: BULK_AWARD_LEADERS_RESET
  }
}


export function setFilter(filterBy) {
  return {
    type: SET_FILTER,
    filterBy
  }
}

export function setLeadersParams(options) {
  return {
    type: SET_PARAMS,
    options
  }
}

export function resetLeaderDetail() {
  return {
    type: RESET_LEADER_DETAIL
  }
}
